/** 인증 관련 API 호출 wrapper. */

import axios from "axios";

import { apiClient } from "./client";

export interface TokenResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
}

export interface UserOut {
  id: number;
  email: string;
  role: string;
  is_active: boolean;
  /** M12 — 관리자에 의해 강제 재설정된 비밀번호. true 면 강제 변경 모달 트리거. */
  must_change_password: boolean;
}

/** 셀프 비밀번호 변경 — 성공 시 새 토큰 쌍 발급. */
export async function changeMyPassword(
  currentPassword: string,
  newPassword: string,
): Promise<TokenResponse> {
  const res = await apiClient.post<TokenResponse>("/auth/change-password", {
    current_password: currentPassword,
    new_password: newPassword,
  });
  return res.data;
}

/** OAuth2 password 플로우 — form-urlencoded 로 전송. */
export async function login(email: string, password: string): Promise<TokenResponse> {
  // 로그인 시점엔 token 이 없으므로 raw axios 사용 (인터셉터 우회)
  const form = new URLSearchParams();
  form.set("username", email);
  form.set("password", password);

  const res = await axios.post<TokenResponse>("/api/auth/login", form, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return res.data;
}

export async function fetchMe(): Promise<UserOut> {
  const res = await apiClient.get<UserOut>("/auth/me");
  return res.data;
}
